import qs from 'qs';
import { toast } from 'react-toastify';
import { actions } from 'forms/rrf';
import { destandard, objectToFormData } from '../utils/commonFunctions';
import api from '../irelandApi';
import {
  GET_PIP_EPOS_SUBMISSION_LIST_PENDING,
  GET_PIP_EPOS_SUBMISSION_LIST_FULFILLED,
  GET_PIP_EPOS_SUBMISSION_LIST_REJECTED,
  GET_PIP_EPOS_SUBMISSION_PENDING,
  GET_PIP_EPOS_SUBMISSION_FULFILLED,
  GET_PIP_EPOS_SUBMISSION_REJECTED,
  PATCH_VALIDATE_PIP_EPOS_SUBMISSION_PENDING,
  PATCH_VALIDATE_PIP_EPOS_SUBMISSION_FULFILLED,
  PATCH_VALIDATE_PIP_EPOS_SUBMISSION_REJECTED,
  PATCH_DECLINE_PIP_EPOS_SUBMISSION_PENDING,
  PATCH_DECLINE_PIP_EPOS_SUBMISSION_FULFILLED,
  PATCH_DECLINE_PIP_EPOS_SUBMISSION_REJECTED
} from '../reducers/pipEposSubmissionsReducer';
import ToastMessage from '../components/common/toast-message';
import { history } from '../store';
import { isAbmLoggedIn } from '../utils/tokenUtils';

const pipEposSubmissionUrl = '/api/submissions/create_missing_pip_epos';
const adminPipEposSubmissionUrl = '/api/admin/pip_epos_submissions';

const preparePipEposSubmissionPayload = (payload) => {
  const pipEposSubmissionData = destandard(payload);
  const pipEposDataMissingWeeksPacks = Object
    .entries(pipEposSubmissionData.products)
    .map(([key, value]) => ({ id: key, number_of_packs_sold: value }));

  delete pipEposSubmissionData.proof_of_purchases;
  delete pipEposSubmissionData.products;
  delete pipEposSubmissionData.week_of_sale;

  pipEposSubmissionData.proof_of_purchases_attributes =
    Object.assign({}, ...pipEposSubmissionData.proof_of_purchases_attributes);
  pipEposSubmissionData.pip_epos_data_missing_weeks_packs = pipEposDataMissingWeeksPacks;

  return objectToFormData(pipEposSubmissionData, 'submission');
};

const preparePipEposProofOfPurchasesPayload = (payload) => {
  const pipEposSubmissionData = destandard(payload);

  pipEposSubmissionData.pip_epos_proof_of_purchases_attributes =
    Object.assign({}, ...pipEposSubmissionData.pip_epos_proof_of_purchases_attributes);

  delete pipEposSubmissionData.pip_epos_proof_of_purchases;

  return objectToFormData(pipEposSubmissionData, 'pip_epos_submission');
};

const redirectAfterAudit = (nextPipEposSubmission) => {
  const pathType = isAbmLoggedIn() ? 'team' : 'admin';
  const path = `/${pathType}/pip_epos_submissions`;

  if (nextPipEposSubmission) {
    history.push(`${path}/${nextPipEposSubmission}`);
  } else {
    history.push(path);
  }
};

export const getPipEposSubmissions = (
  search,
  weekOfSaleFrom,
  weekOfSaleTo,
  status,
  objectiveId,
  page = 1
) => (dispatch) => {
  dispatch({ type: GET_PIP_EPOS_SUBMISSION_LIST_PENDING });

  const query = {
    search,
    week_of_sale_from: weekOfSaleFrom,
    week_of_sale_to: weekOfSaleTo,
    status,
    objective_id: objectiveId
  };

  return api.get(`${adminPipEposSubmissionUrl}?${qs.stringify({ query }, { encodeValuesOnly: true })}&page=${page}`)
    .then((response) => {
      dispatch({
        type: GET_PIP_EPOS_SUBMISSION_LIST_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PIP_EPOS_SUBMISSION_LIST_REJECTED,
        payload: error.response
      });
    });
};

export const getPipEposSubmission = id => (dispatch) => {
  dispatch({ type: GET_PIP_EPOS_SUBMISSION_PENDING });

  return api.get(`${adminPipEposSubmissionUrl}/${id}`)
    .then((response) => {
      dispatch({
        type: GET_PIP_EPOS_SUBMISSION_FULFILLED,
        payload: response.data
      });
      dispatch(actions.change('deep.admin_pip_epos_submissions.notes', response.data.data.attributes.notes));
      dispatch(actions.change(
        'deep.admin_pip_epos_submissions.pip_epos_proof_of_purchases_attributes',
        response.data.data.attributes['pip-epos-proof-of-purchases-attributes']
      ));
    })
    .catch((error) => {
      dispatch({
        type: GET_PIP_EPOS_SUBMISSION_REJECTED,
        payload: error.response
      });
    });
};

export const validatePipEposSubmission = (id, data) => (dispatch) => {
  dispatch({ type: PATCH_VALIDATE_PIP_EPOS_SUBMISSION_PENDING });

  return api.patch(`${adminPipEposSubmissionUrl}/${id}/validate`, preparePipEposProofOfPurchasesPayload(data))
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Pip epos submission validated successfully" />);
      dispatch(actions.reset('deep.admin_pip_epos_submissions'));
      dispatch({
        type: PATCH_VALIDATE_PIP_EPOS_SUBMISSION_FULFILLED,
        payload: response.data
      });
      redirectAfterAudit(response.data.data.attributes['next-pip-epos-submission']);
    })
    .catch((error) => {
      dispatch({
        type: PATCH_VALIDATE_PIP_EPOS_SUBMISSION_REJECTED,
        payload: error.response
      });
      toast.error(<ToastMessage iconStyle="error" message={error.response.data.message} />);
    });
};

export const declinePipEposSubmission = (id, data) => (dispatch) => {
  dispatch({ type: PATCH_DECLINE_PIP_EPOS_SUBMISSION_PENDING });

  return api.patch(`${adminPipEposSubmissionUrl}/${id}/decline`, preparePipEposProofOfPurchasesPayload(data))
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Pip epos submission declined successfully" />);
      dispatch({
        type: PATCH_DECLINE_PIP_EPOS_SUBMISSION_FULFILLED,
        payload: response.data
      });
      redirectAfterAudit(response.data.data.attributes['next-pip-epos-submission']);
    })
    .catch((error) => {
      dispatch({
        type: PATCH_DECLINE_PIP_EPOS_SUBMISSION_REJECTED,
        payload: error.response
      });
      toast.error(<ToastMessage iconStyle="error" message={error.response.data.message} />);
    });
};

export const createPipEposSubmission = payload =>
  api.post(pipEposSubmissionUrl, preparePipEposSubmissionPayload(payload))
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Pip Epos Submission created successfully" />);
      history.push('/submissions#auto_epos_price_it_plus_uploader');
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message={error.response.data.message} />);
    });
